import React, { useEffect, useState } from 'react';
import MediaViewer, { PreviewFile } from './MediaViewer';
import { Size } from '../../../Enums/Size.enum';
import Modal from '../../BaseModule/Components/Modal';

interface MediaViewerModalProps {
	opened: boolean;
	onClose: any;
	params?: any;
	file: PreviewFile;
}

export default function MediaViewerModal(props: MediaViewerModalProps) {
	const { opened, params, file, onClose } = props;
	const [title, setTitle] = useState<string | undefined>(undefined);

	let size = Size.LG;

	useEffect(() => {
		setTitle(file?.displayName);
	}, [file]);

	const modalParams: any = {};
	if (file?.type === 'image') {
		modalParams['maxHeight'] = true;
	}
	if (file?.type === 'pdf') {
		modalParams['maxHeight'] = true;
		size = Size.FULLSCREEN;
	}

	return (
		<Modal opened={opened} onClose={onClose} size={size} {...modalParams}>
			<Modal.Header title={title} />
			<Modal.Content {...modalParams}>
				<MediaViewer file={file} onSuccess={onClose} params={params} />
			</Modal.Content>
		</Modal>
	);
}
